// "/": the links page. A sign-in comes back to the page it started from
// (auth/session.ts), so there is no saved route to restore here. The page is
// the same lazily loaded chunk as /links (App.tsx's Suspense covers it).
import { lazy } from "react";

const Links = lazy(() => import("@links/pages/Links"));

export default function RouteHandler() {
  return <Links />;
}
